import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import IndImg1 from "../images/IndImg1.jpg";
import IndImg2 from "../images/retaillight.avif";
import IndImg3 from "../images/IndImg3.jpg";
import IndImg5 from "../images/IndImg5.jpg";
import food from "../images/food.png";
import healthcare from "../images/healthcare.avif";

import fmcg from "../images/fmcg1.avif";

function IndustrySector() {
  return (
    <IndustrySectorCon>
      <h2>Industry Sector</h2>
      <div>
        Industry sectors Regardless of your industry, your commodity, or your
        key markets, Integral Freight offers global and local logistics
        solutions that enable small and large businesses to grow.
      </div>
      <center>
        <div className="IndustrySec" id="IndustrySec">
          {IndustrySectorData.map((Industry) => (
            <div className="gItem">
              <div className="Image">
                <img
                  className="IndustryImage"
                  src={Industry.image}
                  alt={Industry.title}
                />
              </div>
              <br />
              <center>
                <button>
                  <Link to={Industry.link} className="IndSecBtn">
                    {Industry.title}
                  </Link>
                </button>
              </center>
            </div>
          ))}
        </div>
      </center>
    </IndustrySectorCon>
  );
}

export default IndustrySector;

export const IndustrySectorData = [
  {
    image: fmcg,
    title: "FMCG",
    link: "/FmcgCon",
  },
  {
    image: IndImg2,
    title: "Retail",
    link: "/RetailCon",
  },

  {
    image: IndImg1,
    title: "Chemicals",
    link: "/Chemicals",
  },
  {
    image: IndImg5,
    title: "AutoMotives",
    link: "/AutoMotivesCon",
  },
  {
    image: food,
    title: "Food",
    link: "/FoodCon",
  },
  {
    image: healthcare,
    title: "HealthCare",
    link: "/HealthCareCon",
  },
];

const IndustrySectorCon = styled.div`
  margin-top: 30px;
  margin-down: 30px;

  .IndustrySec {
    width: 75vw;
    border: 1px solid gainsboro;
    padding: 10px 0px;

    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 30px;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 50px;
  }

  .Image {
    width: 150px;
    height: 165px;
  }
  .Image .IndustryImage {
    width: 100%;
    height: 100%;
    border-radius: 50px 50px 50px 50px;
  }

  .IndSecBtn {
    color: white;
  }
`;
